import React from 'react';
import { FixedSizeList } from 'react-window';
import '../App.css';

const VirtualList = ({ items, itemHeight, itemCount }) => {
  return (
    <FixedSizeList
      height={890}
      width={200}
      itemSize={itemHeight}
      itemCount={itemCount}
    >
      {({ index, style }) => (
        <div id='list_img' style={{ ...style,height:`${itemHeight}px`,border: '1px solid #ccc',
        boxSizing: 'border-box'}}>
          <img
            src={items[index]}
            alt={`Item ${index}`}
            style={{
              width: '100%',
              
            }}
          />
          <span className="imgNum" style={{ position: 'absolute', bottom: 0, left: 0 }}>
            Figure {index + 1}
          </span>
          <span className="bregma" style={{ position: 'absolute', bottom: 0, right: 0 }}>
            Bregma-
          </span>
        </div>
      )}
    </FixedSizeList>
  );
};

export default VirtualList;
